import React, { useEffect, useState } from 'react'
import { StyledSkillCategoryContainer } from './styled'
import { SkillCategoryContainerProps } from './types'
import { useFormContext } from 'react-hook-form'

export const SkillCategoryContainer: React.FC<SkillCategoryContainerProps> = props => {
  const { getValues } = useFormContext()

  const skillsCount = () => {
    const key = 'categorizedSkills'
    const selectedSkills = getValues(key)

    return Object.values(selectedSkills || {}).map((skills: any[]) => skills.length).reduce((acc, count) => acc + count, 0)
  }

  const getErrorMessages = () => {
    return skillsCount() < 100 ? [] : ['スキル選択の上限数に達したため入力できません。']
  }

  return (
    <StyledSkillCategoryContainer {...props} errorMessages={getErrorMessages()} />
  )
}
